/* DL Discount — small, dependency-free behaviours for the dl-* sections. */
(function () {
  'use strict';
  if (window.__dlThemeLoaded) return;
  window.__dlThemeLoaded = true;

  var store = {
    get: function (k) { try { return JSON.parse(window.localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Header height var (for sticky offsets) ---------- */
  function trackHeader() {
    var hdr = document.querySelector('[data-dl-header]');
    if (!hdr) return;
    var set = function () {
      var sticky = hdr.hasAttribute('data-sticky');
      document.documentElement.style.setProperty('--dl-header-h', sticky ? hdr.offsetHeight + 'px' : '0px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(hdr);
  }

  /* ---------- Drawer (mobile / "All" menu) ---------- */
  function initDrawer() {
    var lastFocus = null;
    function drawer() { return document.getElementById('DlDrawer'); }
    function setExpanded(v) {
      document.querySelectorAll('[data-dl-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', v); });
    }
    function open(trigger) {
      var d = drawer(); if (!d) return;
      lastFocus = trigger || document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dl-lock');
      setExpanded('true');
      var first = d.querySelector('.dl-drawer__panel a, .dl-drawer__panel button, .dl-drawer__panel summary');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      var d = drawer(); if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dl-lock');
      setExpanded('false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-dl-drawer-open]');
      if (o) { e.preventDefault(); open(o); return; }
      if (e.target.closest('[data-dl-drawer-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(d.querySelectorAll('a[href], button:not([disabled]), summary, input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScroller(root) {
    if (root.__dl) return;
    root.__dl = true;
    var track = root.querySelector('[data-dl-track]');
    var prev = root.querySelector('[data-dl-prev]');
    var next = root.querySelector('[data-dl-next]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    if (root.__dl) return;
    root.__dl = true;
    var track = root.querySelector('[data-dl-hero-track]');
    if (!track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('[data-dl-dot]');
    var n = slides.length;
    var idx = 0;
    var timer = null;
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function goTo(i) {
      idx = (i + n) % n;
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    function syncDots() {
      idx = current();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      Array.prototype.forEach.call(slides, function (s, k) { s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); s.inert = k !== idx; });
    }
    root.querySelectorAll('[data-dl-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { stop(); goTo(current() - 1); }); });
    root.querySelectorAll('[data-dl-hero-next]').forEach(function (b) { b.addEventListener('click', function () { stop(); goTo(current() + 1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); goTo(k); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
    syncDots();
    var speed = parseInt(root.getAttribute('data-autoplay'), 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() { if (speed > 0 && n > 1 && !reduce && !(window.Shopify && window.Shopify.designMode)) timer = setInterval(function () { goTo(current() + 1); }, speed * 1000); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('touchstart', stop, { passive: true });
    start();
  }

  /* ---------- Quick add (single-variant cards) ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-dl-quick-add]');
      if (!form) return;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart || typeof cart.renderContents !== 'function') return; // fall back to normal POST → /cart
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var fd = new FormData(form);
      var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      fd.append('sections', sections);
      fd.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.location.href = '/cart'; return; }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dl-quick-add', productVariantId: fd.get('id'), cartData: res });
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; } });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-dl-sticky]');
    if (!bar) return;
    var target = document.querySelector('product-info .product-form__buttons') || document.querySelector('.product-form__buttons');
    var mainBtn = document.querySelector('product-info product-form button[name="add"]') || document.querySelector('product-form button[name="add"]');
    if (!target || !mainBtn) { bar.hidden = true; return; }
    document.body.classList.add('dl-has-sticky');
    var footerSeen = false;
    var show = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show && !footerSeen);
      });
    });
    io.observe(target);
    var foot = document.querySelector('.dl-footer, footer');
    if (foot) new IntersectionObserver(function (en) { footerSeen = en[0].isIntersecting; bar.classList.toggle('is-visible', show && !footerSeen); }).observe(foot);
    var sBtn = bar.querySelector('[data-dl-sticky-btn]');
    var sPrice = bar.querySelector('[data-dl-sticky-price]');
    function syncBtn() {
      sBtn.disabled = mainBtn.disabled;
      var txt = mainBtn.querySelector('span');
      if (txt && mainBtn.disabled) sBtn.textContent = txt.textContent.trim();
      else sBtn.textContent = sBtn.getAttribute('data-label');
    }
    new MutationObserver(syncBtn).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    syncBtn();
    sBtn.addEventListener('click', function () {
      var needsChoice = bar.getAttribute('data-multi') === 'true' && !bar.hasAttribute('data-chosen');
      if (needsChoice) {
        var picker = document.querySelector('variant-selects') || target;
        bar.setAttribute('data-chosen', '');
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        bar.setAttribute('data-chosen', '');
        var v = ev && ev.data && ev.data.variant;
        if (v && sPrice) sPrice.textContent = (v.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      });
    }
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'dl-recently-viewed';
  function recordView() {
    var el = document.querySelector('[data-dl-product-handle]');
    if (!el) return;
    var h = el.getAttribute('data-dl-product-handle');
    var list = store.get(RV_KEY) || [];
    list = list.filter(function (x) { return x !== h; });
    list.unshift(h);
    store.set(RV_KEY, list.slice(0, 12));
  }
  function initRecent(root) {
    if (root.__dl) return;
    root.__dl = true;
    var current = root.getAttribute('data-current') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
    var list = (store.get(RV_KEY) || []).filter(function (h) { return h && h !== current; }).slice(0, limit);
    var track = root.querySelector('[data-dl-track]');
    if (!list.length || !track) { if (!window.Shopify || !Shopify.designMode) root.hidden = true; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=dl-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(function (c) { return c && c.indexOf('dl-card') > -1; }).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      if (!html) { root.hidden = true; return; }
      track.innerHTML = html;
      root.hidden = false;
      window.dispatchEvent(new Event('resize'));
    });
  }

  /* ---------- Back to top ---------- */
  function initTop() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dl-top]')) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var skip = document.getElementById('MainContent');
      if (skip) skip.focus({ preventScroll: true });
    });
  }

  /* ---------- Newsletter / misc ---------- */
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dl-scroller]').forEach(initScroller);
    (scope || document).querySelectorAll('[data-dl-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-dl-recent]').forEach(initRecent);
  }

  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    trackHeader();
    initDrawer();
    initQuickAdd();
    initTop();
    recordView();
    initAll();
    initSticky();
  }

  if (document.readyState === 'complete') boot();
  else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    if (e.target.querySelector('[data-dl-header]')) { trackHeader(); }
  });
})();
